import type { AnyStepConfiguration } from '@flows/core/types/stepTypes'
import { SubFlow } from '@flows/insurance/types/subFlowTypes'

const failure = () =>
  ({
    stepContent: [
      {
        type: 'title',
        text: {
          type: 'translatableText',
          translationKey: 'sharedFlows_common:steps.failure.title',
        },
      },
      {
        type: 'text',
        text: {
          type: 'translatableText',
          translationKey: 'sharedFlows_common:steps.failure.body',
        },
      },
    ],
    subFlow: SubFlow.Common,
    hideBackButton: true,
    footer: { hideFooter: true },
  }) as const satisfies AnyStepConfiguration

export default failure
